<!-- 创建时间2023/06/20 14:02:09 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：表单-主要信息-自定义 -->
<template>
  <yxt-select 
    v-if="type === 3"
    class="width-percent-100-i"
    v-model="attr.value"
    :placeholder="$t('pc_biz_lbl_selectthings'/* 请选择 */, [config.attrName])"
    :disabled="disabled"
    clearable>
    <yxt-option
      v-for="item in options"
      :key="item"
      :label="item"
      :value="item"
    >
    </yxt-option>
  </yxt-select>
  <yxt-date-picker
    v-else-if="type === 2"
    class="width-percent-100-i"
    v-model="attr.value"
    type="date"
    :disabled="disabled"
    value-format="yyyy-MM-dd"
    :format="$t('pc_kng_custom_lbl_yyyy_year_mm_month_dd_day'/** yyyy 年 MM 月 dd 日 */)"
    :placeholder="$t('pc_biz_lbl_selectthings'/* 请选择 */, [config.attrName])"
    :picker-options="{
      disabledDate: disabledDate
    }"
  >
  </yxt-date-picker>
  <yxt-input
    v-else-if="type === 1"
    class="width-percent-100-i"
    v-model="attr.value"
    :placeholder="$t('pc_biz_lbl_inputthings' /* 请填写 */, [config.attrName])"
    :disabled="disabled"
    :minlength="rangeMin"
    :maxlength="rangeMax"
  ></yxt-input>
  <yxt-input-number
    v-else
    v-model="attr.value"
    class="width-percent-100-i"
    :placeholder="$t('pc_biz_lbl_inputthings' /* 请填写 */, [config.attrName])"
    :min="rangeMin"
    :max="rangeMax"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'form-base-custom',
  inject: ['getAttrConfigs'],
  props: {
    attr: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  watch: {
    'attr.value'(val) {
      if (this.config.history === 1) {
        this.info.code = val;
      } else if (this.config.history === 2) {
        this.info.customVersion = val;
      }
    }
  },
  computed: {
    attrConfigs() {
      return this.getAttrConfigs();
    },
    config() {
      return this.attrConfigs.find(item => item.id === this.attr.attrId) || {};
    },
    options() {
      return this.config.optionList || [];
    },
    type() {
      return ~~this.config.attrType;
    },
    value_: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('update:value', val);
      }
    },
    rangeMin() {
      if (this.type === 2) {
        try {
          if (this.config.rangeMin) {
            return new Date(this.config.rangeMin).getTime();
          }
        } catch (e) {}
        return '';
      } else if (this.type === 1) {
        try {
          if (this.config.rangeMin) {
            return this.config.rangeMin;
          }
        } catch (e) {}
        return '';
      }
      try {
        if (this.config.rangeMin) {
          return ~~this.config.rangeMin;
        }
      } catch (e) {}
      return '';
    },
    rangeMax() {
      if (this.type === 2) {
        try {
          if (this.config.rangeMax) {
            return new Date(this.config.rangeMax).getTime();
          }
        } catch (e) {}
        return '';
      } else if (this.type === 1) {
        try {
          if (this.config.rangeMax) {
            return this.config.rangeMax;
          }
        } catch (e) {}
        return '';
      }
      try {
        if (this.config.rangeMax) {
          return ~~this.config.rangeMax;
        }
      } catch (e) {}
      return '';
    }
  },
  methods: {
    disabledDate(time) {
      const valueTime = time.getTime();
      return (
        (this.rangeMin && valueTime < this.rangeMin) ||
        (this.rangeMax && valueTime > this.rangeMax)
      );
    }
  }
};
</script>